export default __webpack_public_path__ + "static/media/instagram.ec2493e2.svg";